import { Component, OnDestroy, OnInit } from '@angular/core';
import { ZipCodeRangeModel } from '../../../shared/models/zip-code-range.model';
import { FreightCalculatorService } from '../../../shared/services/freight-calculator.service';
import { DeliveryStepsService } from '../../../payment/services/delivery-steps.service';
import { ResumeUpdaterService } from '../../services/cart-resume-updater.service';
import { DistanceToDeadlineService } from '../../../payment/services/distance-to-deadline.service';
import { CartRowsUpdaterService } from '../../services/cart-rows-updater.service';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@AutoUnsubscribe()
@Component({
    selector: 'cart-resume-freight',
    templateUrl: './cart.resume.freight.component.html',
    styleUrls: ['./../../cart.component.scss']
})
export class CartResumeFreightComponent implements OnDestroy, OnInit, OnDestroy {
    public calculating = false;
    public loading = false;
    public zipCode = '';
    public zipCodeRanges: Array<ZipCodeRangeModel> = [];

    freightCalculatorServiceCalculating: Subscription;
    freightCalculatorServiceCalculated: Subscription;
    deliveryStepsServiceSelectedFreight: Subscription;
    deliveryStepsServiceResetedSelectedFreight: Subscription;
    cartRowsServiceIndexed: Subscription;

    constructor(
        protected resumeUpdaterService: ResumeUpdaterService,
        protected freightCalculatorService: FreightCalculatorService,
        protected deliveryStepsService: DeliveryStepsService,
        protected distanceToDeadlineService: DistanceToDeadlineService,
        protected cartRowsService: CartRowsUpdaterService,
        protected toastr: ToastrService,
        protected translate: TranslateService
    ) { }

    ngOnInit() {
        this.freightCalculatorServiceCalculating = this.freightCalculatorService.calculating$.subscribe(() => {
            this.loading = true;
        });
        this.freightCalculatorServiceCalculated = this.freightCalculatorService.calculated$
            .subscribe((options: Array<ZipCodeRangeModel>) => {
                this.zipCodeRanges = options;
                this.loading = false;
                this.calculating = false;

                if (this.zipCodeRanges.length === 0) {
                    this.translate
                    .get('CART.RESUME.EMPTY_ZIP_CODE_RANGES')
                    .subscribe(error => this.toastr.error(error));
                }
            });
        this.deliveryStepsServiceSelectedFreight = this.deliveryStepsService.selectedFreight$
            .subscribe(() => {
                this.deliveryStepsService.inputtedZipCode = this.zipCode;
                this.resumeUpdaterService.refresh().subscribe();
            });
        this.deliveryStepsServiceResetedSelectedFreight = this.deliveryStepsService.resetedSelectedFreight$
            .subscribe(() => {
                this.resumeUpdaterService.refresh().subscribe();
            });
        this.cartRowsServiceIndexed = this.cartRowsService.indexed$.subscribe(() => {
            if (this.zipCodeRanges.length > 0) {
                this.calculateFreight();
            }
        });
    }
    ngOnDestroy() {
        this.zipCode = '';
        this.zipCodeRanges = [];
    }

    public calculateFreight() {
        const zipCode = this.zipCode.replace(/\D/g, '');
        if (zipCode.length === 8) {
            this.freightCalculatorService
                .calculate(zipCode)
                .subscribe();
        } else {
            this.calculating = true;
            this.zipCodeRanges = [];
        }
    }
    public distanceToDeadline(timeCost: string) {
        return this.distanceToDeadlineService.calculate(timeCost);
    }
    public hasDefinedLimit(zipCodeRange: ZipCodeRangeModel): boolean {
        if (zipCodeRange.time_cost_limit === null) {
            return false;
        }

        const deadlineLimitDistance = this.distanceToDeadline(zipCodeRange.time_cost_limit);
        const deadlineDistance = this.distanceToDeadline(zipCodeRange.time_cost);
        const difference = (deadlineLimitDistance - deadlineDistance);

        return zipCodeRange.time_cost_limit !== null && difference > 0;
    }
    public cancelCalculating() {
        this.zipCode = '';
        this.calculating = false;
        this.zipCodeRanges = [];
    }

    /**
     * Load zip code mask pattern.
     * */
    public loadZipCodeMask() {
        return [
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/
        ];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/cart/resume/freight/cart.resume.freight.component.ts